var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTree4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.13 157.06",
    style: {
      enableBackground: "new 0 0 81.13 157.06"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.t40{fill:#D4D3D7;}\n\t.t41{fill:#6C401D;}\n\t.t42{fill:#945225;}\n\t.t43{fill:#09A959;}\n\t.t44{fill:#32B566;}\n\t.t45{fill:#068C45;}\n\t.st0{transform-origin: 50% 50%; transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st4{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st5{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 t40",
    cx: 40.12,
    cy: 151.42,
    rx: 31.4,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1 t41",
    points: "45.27,100.54 35.86,100.54 31.86,152.15 49.27,152.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2 t42",
    points: "40.57,152.15 49.27,152.15 45.27,100.54 40.57,100.54  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3 t43",
    cx: 40.57,
    cy: 51.66,
    rx: 40.57,
    ry: 51.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4 t44",
    cx: 40.59,
    cy: 26.72,
    rx: 26.67,
    ry: 21.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5 t45",
    d: "M40.59,83.18c-15.74,0.01-30.51-7.6-39.64-20.42c3.99,23.19,20.21,40.55,39.62,40.55 c19.38,0,35.58-17.31,39.6-40.45C71.03,75.62,56.29,83.19,40.59,83.18z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTree4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree4.c5d7419b834b72e17ffedbd431b51a23.svg";